import svg from '../../icons/icon-logo-ct.svg'

export default class Footer {
    static init() {
        const block = document.querySelector('.footer')

        if (block) {
            new Footer(block)
        }
    }

    constructor(block) {
        const logo = block.querySelector('.footer__logo')

        let icon = logo.querySelector('svg')

        icon.insertAdjacentHTML('afterbegin', svg)
    }
}
